export const TARIFF_VARIATION = {
  PERCENTAGE: 'percentage',
  FLAT_PRICE: 'flat_price',
};

export const DISCLOSURE_VIEWED_SESSION_DETAIL = {
  NAME: 'PDP_tariff_disclosure_viewed',
  VALUES: {
    DISCLOSURE_VISIBLE: '0',
    TOOLTIP_VISIBLE: '1',
    DISCLOSURE_HIDDEN: '2',
  },
};

export const FLAT_RATE_TARIFF_ELIGIBLE_SESSION_DETAIL = {
  NAME: 'PDP_tariff_eligible_zero_rate',
  VALUES: {
    ELIGIBLE: '1',
  },
};

// TODO: Pull this value from store_surcharge
export const TARIFF_MIN_PRICE_THRESHOLD = 25;
